import { useContext, useMemo } from 'react';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  IObjektVy,
  BusinessCollectionCompType,
} from '../../../../../Types/ObjektVy';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import useNodeQuery from '../../../../../Components/QueryComponents/NodeQuery/useNodeQuery';
import query from './Queries/UserQuery.gql';

import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import AttributeHeader from '../../../../../Components/Attributes/AttributeHeader/AttributeHeader';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import {
  definedSelectedId,
  selectedId,
} from '../../../../../Components/MasterDetail/MasterDetailUtils';
import {
  UserQuery,
  UserQueryVariables,
  UserQuery_node_TEDSYSUser,
} from './Queries/_QueryTypes/UserQuery';
import AddFranvaroButton from './Components/AddFranvaroButton/AddFranvaroButton';
import { FranvaroContext } from './Context/FranvaroContext/FranvaroContext';
import { FranvaroView } from './Components/FranvaroView/FranvaroView';
import { FranvaroReservForView } from './Components/FranvaroReservFor/FranvaroReservForView';

const userModel: IClientBusinessModel =
  clientAvenyModel.SYS.BusinessModels.SYSUser;

const User: BusinessCollectionCompType = props => {
  const franvaroContext = useContext(FranvaroContext);

  const id = props.id ? props.id : '';
  const {
    nodeData,
    loading: nodeLoading,
    refetch,
  } = useNodeQuery<UserQuery, UserQuery_node_TEDSYSUser, UserQueryVariables>(
    query,
    selectedId(props.id),
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      skip: !props.id,
      variables: {
        id: definedSelectedId(id),
        toDate: new Date().toLocaleDateString('sv-SE'),
      },
    }
  );

  const attestrattConfig = useMemo<IAssociationListConfig>(() => {
    return {
      defaultVisningstyp: 'lista',
      inCard: true,
      customDefaultColumns: [
        {
          attributeDef: 'BENAMNING',
          caption: 'Namn',
          header: true,
        },
        { attributeDef: 'SIGNATUR' },
      ],
    };
  }, []);

  const franvaroVyer = useMemo(() => {
    return [FranvaroView];
  }, []);

  const franvaroReservForVyer = useMemo(() => {
    return [FranvaroReservForView];
  }, []);

  return (
    <BusinessDataForm<UserQuery_node_TEDSYSUser>
      isNew={props.isNew}
      data={nodeData}
      fullScreen={props.config?.fullPage ?? false}
      refetchData={refetch}
      dataLoading={nodeLoading}
      model={userModel}
    >
      <ObjektVy nodeLoading={nodeLoading}>
        <ObjektVySida
          sidNr={1}
          caption="Användare"
          collectionName={userModel.CollectionName}
          columns={2}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage>
              <AttributGrupp>
                <AttributeHeader attributeGroups={['SIGNATURE', 'Name']} />
              </AttributGrupp>
            </ObjektVyKolumn>
            <ObjektVyKolumn>
              <ObjektVyKort caption="Attesträtter">
                {id && (
                  <AssociationList
                    associationName="Attestant"
                    associationPath="Attestant"
                    collectionName={'SYSUser'}
                    ownId={selectedId(id)}
                    config={attestrattConfig}
                  />
                )}
              </ObjektVyKort>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
        <ObjektVySida
          sidNr={2}
          caption="Frånvaro"
          collectionName={userModel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn>
              <AttributGrupp>
                <AttributeHeader attributeGroups={['Name']} />
              </AttributGrupp>
            </ObjektVyKolumn>
            <ObjektVyKolumn fullPage>
              <ObjektVyKort
                bmod={userModel}
                button={() => (
                  <AddFranvaroButton
                    setEditFranvaro={franvaroContext.setEditFranvaro}
                    setDialogOpen={
                      franvaroContext.setRegisterFranvaroDialogOpen
                    }
                  />
                )}
                caption="Frånvaro"
                id={props.id ?? ''}
                vyer={franvaroVyer}
              />
            </ObjektVyKolumn>
            <ObjektVyKolumn fullPage>
              <ObjektVyKort
                bmod={userModel}
                caption="Reserv för"
                id={props.id ?? ''}
                vyer={franvaroReservForVyer}
              />
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

const UserObjektVy = collectionCompToObjektVy(User, 'User');

export const UserVyer: IObjektVy[] = [UserObjektVy];
